export default __webpack_public_path__ + "static/media/package-set-icon.b8455fbe.svg";